/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { max, range } from 'lodash';
import { ChartLegendCell } from '../../charts.model';

@Component({
  selector: 'gh-chart-legend',
  template: require('./chart-legend.component.html'),
  styles: [require('./chart-legend.component.scss')],
})
export class ChartLegendComponent {
  private _cells: Maybe<ChartLegendCell>[][];

  @Input()
  set cells(rows: Maybe<ChartLegendCell>[][]) {
    // transpose layout
    const rowIndexes = range(max(rows.map((row) => row.length)) || 0);
    const cellIndexes = range(rows.length);

    this._cells = rowIndexes.map((i) => cellIndexes.map((j) => rows[j][i]));
  }

  get cells(): Maybe<ChartLegendCell>[][] {
    return this._cells;
  }
}
